<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :sub-type="subType"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Products/ProductSubTypes/Form.vue'

const props = defineProps({
    subType: {
        type: Object,
        default: () => {
            return {}
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.put(route('products.sub-types.update', { sub_type: props.subType.id }))
}
</script>
